import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const SEOMetaDescription = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14917)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FFEDBF"
          />
          <path
            d="M175.954 41.8522V114.831C175.954 117.251 174.993 119.571 173.282 121.282C171.571 122.993 169.251 123.954 166.831 123.954H80.1687C77.7493 123.954 75.4289 122.993 73.7182 121.282C72.0074 119.571 71.0463 117.251 71.0463 114.831V41.8522H175.954Z"
            fill="#66E1FF"
          />
          <path
            d="M71.0463 41.8522V114.831C71.0463 117.251 72.0074 119.571 73.7182 121.282C75.4289 122.993 77.7493 123.954 80.1687 123.954H84.7299L166.831 41.8522H71.0463Z"
            fill="#C2F3FF"
          />
          <path
            d="M175.954 41.8523H71.0463V28.1687C71.0463 25.7493 72.0074 23.4289 73.7182 21.7182C75.4289 20.0074 77.7493 19.0463 80.1687 19.0463H166.831C169.251 19.0463 171.571 20.0074 173.282 21.7182C174.993 23.4289 175.954 25.7493 175.954 28.1687V41.8523Z"
            fill="white"
          />
          <path
            d="M166.831 19.0463H80.1687C77.7493 19.0463 75.4289 20.0074 73.7182 21.7182C72.0074 23.4289 71.0463 25.7493 71.0463 28.1687V114.831C71.0463 117.251 72.0074 119.571 73.7182 121.282C75.4289 122.993 77.7493 123.954 80.1687 123.954H166.831C169.251 123.954 171.571 122.993 173.282 121.282C174.993 119.571 175.954 117.251 175.954 114.831V28.1687C175.954 25.7493 174.993 23.4289 173.282 21.7182C171.571 20.0074 169.251 19.0463 166.831 19.0463Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.0463 41.8522H175.954"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.0104 31.5896C86.708 31.5896 86.418 31.4694 86.2041 31.2556C85.9903 31.0417 85.8701 30.7517 85.8701 30.4493C85.8701 30.1468 85.9903 29.8568 86.2041 29.6429C86.418 29.4291 86.708 29.309 87.0104 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M87.0104 31.5896C87.3128 31.5896 87.6028 31.4694 87.8167 31.2556C88.0305 31.0417 88.1507 30.7517 88.1507 30.4493C88.1507 30.1468 88.0305 29.8568 87.8167 29.6429C87.6028 29.4291 87.3128 29.309 87.0104 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M100.694 31.5896C100.392 31.5896 100.102 31.4694 99.8877 31.2556C99.6739 31.0417 99.5537 30.7517 99.5537 30.4493C99.5537 30.1468 99.6739 29.8568 99.8877 29.6429C100.102 29.4291 100.392 29.309 100.694 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M100.694 31.5896C100.996 31.5896 101.286 31.4694 101.5 31.2556C101.714 31.0417 101.834 30.7517 101.834 30.4493C101.834 30.1468 101.714 29.8568 101.5 29.6429C101.286 29.4291 100.996 29.309 100.694 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M114.378 31.5896C114.075 31.5896 113.785 31.4694 113.571 31.2556C113.357 31.0417 113.237 30.7517 113.237 30.4493C113.237 30.1468 113.357 29.8568 113.571 29.6429C113.785 29.4291 114.075 29.309 114.378 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M114.378 31.5896C114.68 31.5896 114.97 31.4694 115.184 31.2556C115.398 31.0417 115.518 30.7517 115.518 30.4493C115.518 30.1468 115.398 29.8568 115.184 29.6429C114.97 29.4291 114.68 29.309 114.378 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <circle
            cx="87"
            cy="51.5991"
            r="3.25"
            fill="#191919"
            stroke="black"
            strokeWidth="1.5"
          />
          <path
            d="M86 63.5991H151"
            stroke="#191919"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86 71.5991H134.146"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86 78.4009H124.206"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M187.648 85H146.737C142.564 85 138.562 86.6578 135.611 89.6086C132.66 92.5595 131.002 96.5617 131.002 100.735C131.002 104.908 132.66 108.91 135.611 111.861C138.562 114.812 142.564 116.47 146.737 116.47H187.648C191.821 116.47 195.823 114.812 198.774 111.861C201.725 108.91 203.383 104.908 203.383 100.735C203.383 96.5617 201.725 92.5595 198.774 89.6086C195.823 86.6578 191.821 85 187.648 85Z"
            fill="#C2F3FF"
          />
          <path
            d="M146.737 92.8674H187.648C191.137 92.8669 194.527 94.0259 197.285 96.1621C200.043 98.2983 202.014 101.291 202.886 104.669C203.486 102.343 203.546 99.9113 203.062 97.5591C202.577 95.2069 201.56 92.9969 200.089 91.0983C198.618 89.1998 196.733 87.6631 194.576 86.6061C192.42 85.549 190.05 84.9996 187.648 85H146.737C144.336 84.9996 141.966 85.549 139.809 86.6061C137.653 87.6631 135.767 89.1998 134.296 91.0983C132.825 92.9969 131.809 95.2069 131.324 97.5591C130.839 99.9113 130.899 102.343 131.5 104.669C132.372 101.291 134.342 98.2983 137.1 96.1621C139.859 94.0259 143.249 92.8669 146.737 92.8674Z"
            fill="#66E1FF"
          />
          <path
            d="M187.648 85H146.737C142.564 85 138.562 86.6578 135.611 89.6086C132.66 92.5595 131.002 96.5617 131.002 100.735C131.002 104.908 132.66 108.91 135.611 111.861C138.562 114.812 142.564 116.47 146.737 116.47H187.648C191.821 116.47 195.823 114.812 198.774 111.861C201.725 108.91 203.383 104.908 203.383 100.735C203.383 96.5617 201.725 92.5595 198.774 89.6086C195.823 86.6578 191.821 85 187.648 85Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M181.571 107.463C183.715 107.463 185.772 106.611 187.288 105.095C188.804 103.579 189.656 101.523 189.656 99.3785C189.656 97.2344 188.804 95.178 187.288 93.6619C185.772 92.1457 183.715 91.2939 181.571 91.2939C179.427 91.2939 177.371 92.1457 175.854 93.6619C174.338 95.178 173.486 97.2344 173.486 99.3785C173.486 101.523 174.338 103.579 175.854 105.095C177.371 106.611 179.427 107.463 181.571 107.463Z"
            fill="#E4F1F5"
          />
          <path
            d="M175.853 105.093C174.357 103.573 173.522 101.523 173.531 99.3902C173.539 97.2572 174.39 95.214 175.898 93.7057C177.407 92.1974 179.45 91.3463 181.583 91.3378C183.716 91.3294 185.766 92.1642 187.286 93.6605L175.853 105.093Z"
            fill="white"
          />
          <path
            d="M187.286 105.094L192.368 110.176"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M181.571 107.463C183.715 107.463 185.772 106.611 187.288 105.095C188.804 103.579 189.656 101.523 189.656 99.3785C189.656 97.2344 188.804 95.178 187.288 93.6619C185.772 92.1457 183.715 91.2939 181.571 91.2939C179.427 91.2939 177.371 92.1457 175.854 93.6619C174.338 95.178 173.486 97.2344 173.486 99.3785C173.486 101.523 174.338 103.579 175.854 105.095C177.371 106.611 179.427 107.463 181.571 107.463Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M156.8 101.208C156.8 100.558 156.742 99.9334 156.633 99.3334H148V102.883H152.933C152.717 104.025 152.067 104.992 151.092 105.642V107.95H154.067C155.8 106.35 156.8 104 156.8 101.208Z"
            fill="#4285F4"
          />
          <path
            d="M148 110.167C150.475 110.167 152.55 109.35 154.067 107.95L151.092 105.642C150.275 106.192 149.233 106.525 148 106.525C145.617 106.525 143.592 104.917 142.867 102.75H139.817V105.117C141.325 108.108 144.417 110.167 148 110.167Z"
            fill="#34A853"
          />
          <path
            d="M142.867 102.742C142.683 102.192 142.575 101.608 142.575 101C142.575 100.392 142.683 99.8083 142.867 99.2583V96.8916H139.817C139.192 98.1249 138.833 99.5166 138.833 101C138.833 102.483 139.192 103.875 139.817 105.108L142.192 103.258L142.867 102.742Z"
            fill="#FBBC05"
          />
          <path
            d="M148 95.4834C149.35 95.4834 150.55 95.95 151.508 96.85L154.133 94.225C152.542 92.7417 150.475 91.8334 148 91.8334C144.417 91.8334 141.325 93.8917 139.817 96.8917L142.867 99.2584C143.592 97.0917 145.617 95.4834 148 95.4834Z"
            fill="#EA4335"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14917">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
